import React, { useState } from 'react';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';

const BulkActionsBar = ({ selectedCount, onBulkAction, onClearSelection }) => {
  const bulkActionOptions = [
    { value: 'confirm', label: 'Confirm Selected' },
    { value: 'complete', label: 'Mark as Completed' },
    { value: 'inprogress', label: 'Mark as Started' },
    { value: 'cancel', label: 'Cancel Selected' },
    { value: 'noshow', label: 'Mark as No Show' },
    { value: 'sendreminder', label: 'Send Reminder' }

  ];

  const [selectedAction, setSelectedAction] = React.useState('');

  const handleApply = () => {
    if (selectedAction) {
      onBulkAction(selectedAction);
      setSelectedAction('');
    }
  };

  if (selectedCount === 0) return null;

  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-40 bg-card border border-border rounded-xl shadow-2xl p-4 w-[calc(100%-2rem)] max-w-2xl">
      <div className="flex flex-col sm:flex-row items-center gap-4">
        <div className="flex items-center gap-2 text-sm font-caption">
          <span className="font-semibold text-primary">{selectedCount}</span>
          <span className="text-muted-foreground">
            {selectedCount === 1 ? 'booking' : 'bookings'} selected
          </span>
        </div>

        <div className="flex-1 flex items-center gap-2 w-full sm:w-auto">
          <Select
            placeholder="Choose action..."
            options={bulkActionOptions}
            value={selectedAction}
            onChange={setSelectedAction}
            className="flex-1"
          />
          <Button
            variant="default"
            onClick={handleApply}
            disabled={!selectedAction}
          >
            Apply
          </Button>
        </div>

        <Button
          variant="ghost"
          size="sm"
          iconName="X"
          onClick={onClearSelection}
        >
          Clear
        </Button>
      </div>
    </div>
  );
};

export default BulkActionsBar;